import script from "./ScheduleManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleManagement.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleManagement.vue?vue&type=style&index=0&id=674ede78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-674ede78"]])

export default __exports__